import { css as p } from "styled-components";
const t = {
  prefix: ({ theme: i }) => /* @__PURE__ */ p([
    "z-index:2;margin-left:",
    ";margin-top:1px;width:0;padding:0;"
  ], i.space.sm),
  input: ({ theme: i }) => /* @__PURE__ */ p([
    "padding-left:",
    ";margin-left:-",
    ";margin-top:0;z-index:1;width:100%;"
  ], i.space.lg, i.space.sm)
};
export {
  t as default
};
